(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-faq';

  function closeItem(item, trigger, answer) {
    item.classList.remove('oddit-section-faq__item--open');
    trigger.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.setAttribute('hidden', '');
  }

  function openItem(item, trigger, answer) {
    item.classList.add('oddit-section-faq__item--open');
    trigger.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    answer.removeAttribute('hidden');
  }

  function filterByCategory(section, category) {
    var items = section.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      if (!category || item.getAttribute('data-category') === category) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  function handleClick(section, e) {
    var trigger = e.target.closest('[data-faq-trigger]');
    if (trigger) {
      var item = trigger.closest('[data-faq-item]');
      if (!item) return;
      var answer = item.querySelector('[data-faq-answer]');
      if (!answer) return;

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeItem(item, trigger, answer);
      } else {
        openItem(item, trigger, answer);
      }
      return;
    }

    var tab = e.target.closest('.oddit-section-faq__tab');
    if (tab) {
      section.querySelectorAll('.oddit-section-faq__tab').forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('oddit-section-faq__tab--active', active);
        t.setAttribute('aria-selected', String(active));
      });
      filterByCategory(section, tab.getAttribute('data-category'));
    }
  }

  function toggleItem(item, open) {
    if (!item) return;
    var trigger = item.querySelector('[data-faq-trigger]');
    var answer = item.querySelector('[data-faq-answer]');
    if (!trigger || !answer) return;
    if (open) {
      openItem(item, trigger, answer);
    } else {
      closeItem(item, trigger, answer);
    }
  }

  function applyInitialCategory(section) {
    var active = section.querySelector('.oddit-section-faq__tab--active');
    if (!active) return;

    filterByCategory(section, active.getAttribute('data-category'));

    var open = section.querySelector(
      '[data-faq-item].oddit-section-faq__item--open'
    );
    if (open && open.style.display !== 'none') return;

    toggleItem(open, false);

    toggleItem(
      Array.prototype.filter.call(
        section.querySelectorAll('[data-faq-item]'),
        function (item) {
          return item.style.display !== 'none';
        }
      )[0],
      true
    );
  }

  function initSection(section) {
    if (!section || section.dataset.odditFaqInit === 'true') return;
    section.dataset.odditFaqInit = 'true';
    section.addEventListener('click', function (e) {
      handleClick(section, e);
    });
    applyInitialCategory(section);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();